import { FC, ReactNode } from 'react';
import { RegionPlaceholder } from './region-placeholder';
import style from './unit-builder-modal.module.scss';

interface UnitBuilderMapPaneProps {
  children?: ReactNode;
}

/**
 * Left pane. One slot: in the mock this whole pane is `EditSlotMap`, which owns
 * its own toolbar (Rotate azimuth, Clone unit), the map, and the Survey Areas /
 * Applicable Areas section beneath it.
 *
 * @param {UnitBuilderMapPaneProps} props - The pane's single slot.
 * @return {JSX.Element} The map pane.
 */
export const UnitBuilderMapPane: FC<UnitBuilderMapPaneProps> = ({
  children,
}) => (
  <div className={style.mapPane} data-unit-builder-pane>
    {children ?? (
      <RegionPlaceholder
        label="Map pane"
        source="One component fills this pane — the Mapbox translation of the mock's EditSlotMap. To be built."
        parts={[
          'Map View toolbar — Rotate azimuth 90°, Clone unit, layer toggles',
          'Map — reuse tc-slot-geometries-layer.tsx + query-map/draw-aoi-control.tsx',
          'Survey Areas / Applicable Areas — survey-description/survey-section.tsx (exists) + use-survey-area-pick.ts',
        ]}
      />
    )}
  </div>
);
